import BackButtonCollapseDashProvider from 'context/dash/BackButtonCollapseDash'
import DetailVisibleProvider from 'context/dash/DetailVisible'
import ShowAllEventsProvider from 'context/dash/ShowAllEvents'
import DashContainer from 'modules/dashboard/_common/DashContainer'
import EstablishmentOrders from 'modules/dashboard/orders/EstablishmentOrders/EstablishmentOrders'

export default function DashEstablishmentOrders() {
    return (
        <BackButtonCollapseDashProvider>
            <ShowAllEventsProvider>
                <DetailVisibleProvider>
                        <DashContainer title={'Pedidos do estabelecimento'}>
                            <EstablishmentOrders />
                        </DashContainer>
                </DetailVisibleProvider>
            </ShowAllEventsProvider>
        </BackButtonCollapseDashProvider>
    )
}
